export const TERMS_DISMISSAL_KEY = 'terms_conditions_dismissed_date';

export const DATES = {
  JULY_FIRST_2025_17_UTC: '2025-07-01T17:00:00Z',
  JULY_31ST_2025_17_UTC: '2025-07-31T17:00:00Z',
} as const;

export const MESSAGES = {
  EXISTING_USER:
    'We have updated our Terms and Conditions. You must review and accept them before August 1st, 2025 to continue using our product.',
  NEW_USER: 'You must accept our Terms and Conditions to start using our product.',
} as const;

export const URLS = {
  TERMS_AND_CONDITIONS: 'https://treble.tech/terms-and-conditions',
} as const;
